import React from "react";

type Currency = "USD" | "GBP" | "EUR";

interface CurrencySelectorProps {
  currency: Currency;
  setCurrency: (currency: Currency) => void;
}

export function CurrencySelector({
  currency,
  setCurrency,
}: CurrencySelectorProps) {
  return (
    <div className="flex justify-center mb-8">
      <div className="inline-flex bg-white/5 rounded-lg p-1">
        <button
          onClick={() => setCurrency("USD")}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
            currency === "USD"
              ? "bg-volt-blue text-white"
              : "text-gray-400 hover:text-white"
          }`}
        >
          USD ($)
        </button>
        <button
          onClick={() => setCurrency("GBP")}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
            currency === "GBP"
              ? "bg-volt-blue text-white"
              : "text-gray-400 hover:text-white"
          }`}
        >
          GBP (£)
        </button>
        <button
          onClick={() => setCurrency("EUR")}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
            currency === "EUR"
              ? "bg-volt-blue text-white"
              : "text-gray-400 hover:text-white"
          }`}
        >
          EUR (€)
        </button>
      </div>
    </div>
  );
}
